<template>
  <div class="relationship-repoint-cell">
    <div class="relationship-repoint-cell__line">
      <relationship-tag-link
        previous
        :name="targets.previous.name"
        :target-id="targets.previous.targetId"
        :facility-id="targets.previous.facilityId" />
      <v-icon x-small class="relationship-repoint-cell__arrow" aria-hidden="true">mdi-arrow-right</v-icon>
      <span class="sr-only">changes to</span>
      <relationship-tag-link
        :name="targets.next.name"
        :target-id="targets.next.targetId"
        :facility-id="targets.next.facilityId" />
    </div>
    <small :title="matchedLabel">{{ matchedLabel }}</small>
  </div>
</template>

<script>
import RelationshipTagLink from './RelationshipTagLink.vue';

// Showcase C, Variant A: the changed link inline as "PT-101 → PT-101A", each name opening its Tag.
export default {
  name: 'RelationshipRepointCell',
  components: { RelationshipTagLink },
  props: {
    targets: { type: Object, required: true },
    sourceValue: { type: String, default: '' },
  },
  computed: {
    matchedLabel() {
      const value = (this.sourceValue || '').trim();
      return value ? `Matched from the source value “${value}”` : 'Matched from the source value';
    },
  },
};
</script>

<style lang="scss" scoped>
.relationship-repoint-cell { display: flex; min-width: 0; flex-direction: column; gap: 3px; }
.relationship-repoint-cell__line { display: flex; min-width: 0; align-items: center; flex-wrap: wrap; gap: 6px; }
.relationship-repoint-cell__arrow { color: var(--run-muted-ink, #5c6b66) !important; }
.relationship-repoint-cell small {
  overflow: hidden;
  color: var(--run-muted-ink, #5c6b66);
  font-size: var(--ds-font-caption);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
</style>
